import SloDropdownFilter from './SloDropdownFilter.vue';
import SloInfiniteHits from './SloInfiniteHits.vue';
import SloInfiniteLoader from './SloInfiniteLoader.vue';
import SloSearchBox from './SloSearchBox.vue';
import SloConfigure from './SloConfigure.vue';
import SloActiveValues from './SloActiveValues.vue';
import SloActiveValuesCount from './SloActiveValuesCount.vue';
import SloActiveValuesToggle from './SloActiveValuesToggle.vue';
import SloFinishFilter from './SloFinishFilter.vue';
import SloTagFilter from './SloTagFilter.vue';

export default {
  'slo-dropdown-filter': SloDropdownFilter,
  'slo-infinite-hits': SloInfiniteHits,
  'slo-infinite-loader': SloInfiniteLoader,
  'slo-search-box': SloSearchBox,
  'slo-configure': SloConfigure,
  'slo-active-values': SloActiveValues,
  'slo-active-values-count': SloActiveValuesCount,
  'slo-active-values-toggle': SloActiveValuesToggle,
  'slo-finish-filter': SloFinishFilter,
  'slo-tag-filter': SloTagFilter
};
